import AutofillSprintConfirmation from './AutofillSprintConfirmation';

export default AutofillSprintConfirmation;
